module.exports = __webpack_public_path__ + "img/New Zealand.cb41d1c5.gif";